<div class="alert-dialog-container" [ngStyle]="getDialogContainerStyle()">
    <div class="alert-dialog-header" *ngIf="data.title">
        <p>{{ data.title }}</p>
    </div>

    <mat-dialog-content class="alert-dialog-content">
        <p>{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-content class="alert-dialog-subcontent" *ngIf="data.submessage">
        <p>{{ data.submessage }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="alert-dialog-actions">
        <button class="cancel-button" (click)="onCancelClick()" [ngStyle]="getCancelButtonStyle()">
            {{ data.cancelText || 'Cancel' }}
        </button>
        <button class="delete-button" (click)="onOkClick()" [ngStyle]="getOkButtonStyle()">
            {{ data.okText || 'OK' }}
        </button>
    </mat-dialog-actions>
</div>